import { j as i } from "./jsx-runtime-3tyXYecC.mjs";
import { f as V } from "./index-LyFokDcn.mjs";
import { c as N } from "./index-DkZ16bcJ.mjs";
import { l as oe } from "./lodash-5ofSKtz3.mjs";
import { useRef as re, useImperativeHandle as ie, useMemo as ne } from "react";
import { I as ae } from "./icon-CvGUqXUP.mjs";
import { I as se } from "./icon-tile-BJ1ib0c2.mjs";
import { I as le } from "./icon-v2-DGtVEk7e.mjs";
import { L as ce } from "./layout-box-DFBM-kSI.mjs";
import { S as de } from "./status-message-BMoS1d1Y.mjs";
import { m as X } from "./tss-DN0acMKN.mjs";
import { M as Y, d as Z } from "./constants-CnFYFetN.mjs";
import { c as pe, t as he, a as me } from "./encore-theme-Bgi7jWdM.mjs";
import { t as ue } from "./theme-colors-uK40SfO5.mjs";
import { s as y } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { g as be } from "./get-aria-describedby-G1wcWKF2.mjs";
const fe = () => (e) => e, ge = X()((e, r, n) => {
  const { borderRadiuses: a, constructs: t, mixins: s, mode: d, palette: o, spacing: l, typography: h } = e, { boxWidth: p, isChecked: b, isDisabled: f, upperContent: u } = r, m = !!u;
  return {
    container: {
      display: "flex",
      flexDirection: "column",
      width: p
    },
    root: {
      alignItems: "start",
      backgroundColor: t.surface.neutral.inverted,
      border: `solid 1px ${t.border.neutral.xWeak}`,
      borderRadius: a[400],
      boxShadow: s.boxShadow("300", t.surface.neutral.xxStrong),
      boxSizing: "border-box",
      display: "inline-flex",
      flexDirection: m ? "column" : "unset",
      flexGrow: 1,
      gap: m ? "unset" : l(2),
      minHeight: "88px",
      outline: d === Y.Dye ? `1px solid ${Z.main}` : void 0,
      padding: l(2.5),
      position: "relative",
      transition: "all ease-out 100ms",
      width: "100%",
      "&:hover": {
        borderColor: o.primary.main,
        cursor: "pointer"
      },
      "&:focus-within": {
        borderColor: o.primary.main,
        boxShadow: `0 0 0 4px ${s.alpha(t.surface.primary.medium, 0.1)}`
      }
    },
    checkbox: {
      alignSelf: "flex-start",
      backgroundColor: t.surface.neutral.xWeak,
      border: `1px solid ${t.border.neutral.medium}`,
      borderRadius: a[100],
      boxShadow: `1px 1px 0 1px ${s.alpha(t.surface.neutral.xxStrong, 0.05)} inset`,
      boxSizing: "border-box",
      display: "flex",
      fill: t.icon.neutral.inverted,
      flex: "0 0 auto",
      height: l(2.5),
      justifyContent: "center",
      position: "relative",
      top: "14px",
      width: l(2.5)
    },
    checkboxInner: {
      alignItems: "center",
      backgroundColor: t.surface.primary.strong,
      borderRadius: a[100],
      boxShadow: s.boxShadow("100", t.surface.neutral.xxStrong),
      display: "flex",
      height: l(2.5),
      justifyContent: "center",
      // so it will size to the outside of the parent's border
      margin: "-1px",
      opacity: 0,
      transform: "scale(0)",
      transition: "opacity 200ms ease, transform 200ms ease",
      width: l(2.5),
      // so it sits on top of its parent's border
      zIndex: "1"
    },
    iconTile: {
      alignSelf: "flex-start"
    },
    inner: {
      alignItems: "center",
      display: "flex",
      flex: 1,
      gap: l(2),
      paddingTop: m ? l(2.5) : "unset",
      width: "100%"
    },
    input: {
      // hide it
      height: 1,
      opacity: 0,
      left: 0,
      top: 0,
      position: "absolute",
      width: 1
    },
    textWrapper: {
      flexGrow: 1,
      overflowWrap: "anywhere"
    },
    truncatedTextWrapper: {
      overflow: "hidden"
    },
    title: {
      color: f ? t.text.neutral.weak : t.text.primary.strong,
      fontSize: h.large.fontSize,
      fontWeight: b ? h.fontWeightBold : h.fontWeightMedium
    },
    description: {
      fontColor: f ? t.text.neutral.weak : t.text.neutral.strong,
      fontSize: h.teenie.fontSize
    },
    truncatedText: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    upperContent: {
      borderRadius: `${a[400]} ${a[400]} 0 0`,
      marginLeft: `-${l(2.5)}`,
      marginRight: `-${l(2.5)}`,
      marginTop: `-${l(2.5)}`,
      width: `calc(100% + (${l(2.5)} * 2))`,
      overflow: "hidden",
      borderBottom: `solid 1px ${t.border.neutral.xWeak}`,
      position: "relative",
      opacity: f ? 0.5 : "unset"
    },
    checked: {
      [`&:not(.${n.disabled})`]: {
        backgroundColor: t.surface.neutral.xxWeak,
        borderColor: t.border.primary.strong
      },
      [`&.${n.disabled}`]: {
        [`& .${n.checkboxInner}`]: {
          backgroundColor: t.surface.neutral.medium,
          boxShadow: "none"
        }
      },
      [`& .${n.checkboxInner}`]: {
        opacity: 1,
        transform: "scale(1)"
      }
    },
    disabled: {
      borderColor: t.border.neutral.weak,
      boxShadow: "none",
      pointerEvents: "none"
    }
  };
});
function T(e, r) {
  return e === !0 ? !0 : r ? !!(e != null && e[r]) : e && (e.title || e.description);
}
const { themeColors: Q } = ue, xe = "lime1", C = Q.find((e) => e.name === xe) || Q[0];
function O(e, r) {
  e = e.replace("#", "");
  const n = parseInt(e.length === 3 ? e.slice(0, 1).repeat(2) : e.slice(0, 2), 16), a = parseInt(e.length === 3 ? e.slice(1, 2).repeat(2) : e.slice(2, 4), 16), t = parseInt(e.length === 3 ? e.slice(2, 3).repeat(2) : e.slice(4, 6), 16);
  return r ? `rgba(${n}, ${a}, ${t}, ${r})` : `rgb(${n}, ${a}, ${t})`;
}
const x = {
  themeBaseDefault: C.base,
  themeLightDefault: C.light,
  themeLighterDefault: C.lighter,
  themeLightestDefault: C.lightest,
  themeLightest10Default: O(C.lightest, "0.1"),
  themeLightest35Default: O(C.lightest, "0.35"),
  themeLightest50Default: O(C.lightest, "0.5")
}, ye = {
  themeBase: `var(--fabric-theme-base, ${x.themeBaseDefault})`,
  themeLight: `var(--fabric-theme-light, ${x.themeLightDefault})`,
  themeLighter: `var(--fabric-theme-lighter, ${x.themeLighterDefault})`,
  themeLightest: `var(--fabric-theme-lightest, ${x.themeLightestDefault})`,
  themeLightest10: `var(--fabric-theme-lightest10, ${x.themeLightest10Default})`,
  themeLightest35: `var(--fabric-theme-lightest35, ${x.themeLightest35Default})`,
  themeLightest50: `var(--fabric-theme-lightest50, ${x.themeLightest50Default})`
}, Se = {
  ...x,
  ...ye
};
function g(e) {
  const n = V.ifFeature("encore", { ...pe, ...he }, { ...me, ...Se })[e];
  return n || (console.error(`The requested color definition (${e.toString()}) does not exist.`), "");
}
const we = fe(), ve = we(["boxWidth", "hasDescription", "hasIcon", "isChecked", "isDisabled", "truncated", "type"]), $ = {
  shouldForwardProp: (e) => !ve.includes(e)
}, E = "themeBase", ee = 2, Ce = y(
  "div",
  $
)(({ boxWidth: e, isChecked: r, isDisabled: n, theme: a }) => {
  const { mode: t, palette: s } = a;
  return {
    display: "inline-block",
    position: "relative",
    borderRadius: ee,
    boxSizing: "border-box",
    outline: t === Y.Dye ? `1px solid ${Z.main}` : void 0,
    pointerEvents: n ? "none" : void 0,
    label: "containerStyle",
    ":focus-within": {
      boxShadow: `0 0 1px 1px ${g("themeLightest")}`
    },
    width: e
  };
}), $e = y(
  "div",
  $
)(({ hasDescription: e }) => e ? {
  display: "flex",
  label: "contentStyle"
} : {
  alignContent: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  label: "contentStyle"
}), je = y(
  "p",
  $
)(({ isDisabled: e, truncated: r, theme: n }) => {
  var s, d;
  const { palette: a, typography: t } = n;
  return {
    color: e ? a.gray[600] : a.gray[700],
    fontSize: (s = t.teenie) == null ? void 0 : s.fontSize,
    label: "descriptionStyle",
    lineHeight: (d = t.teenie) == null ? void 0 : d.lineHeight,
    marginBottom: 0,
    ...T(r, "description") ? {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    } : {}
  };
}), ke = y(
  "span",
  $
)(({ hasDescription: e, isChecked: r, isDisabled: n, theme: a }) => {
  const { palette: t } = a;
  let s = r ? t.primary.main : t.gray[700];
  return n && (s = t.gray[500]), {
    display: "flex",
    fill: s,
    justifyContent: "center",
    margin: `0 ${e ? "13px" : 0} ${e ? 0 : "7px"} 0`,
    paddingTop: e ? "2px" : 0,
    label: "iconStyle"
  };
}), Ie = y(
  "div",
  $
)(
  ({ truncated: e }) => T(e) ? {
    label: "textStyle",
    overflow: "hidden"
  } : {}
), De = y(
  "h6",
  $
)(({ hasDescription: e, isChecked: r, isDisabled: n, truncated: a, theme: t }) => {
  var l;
  const { palette: s, typography: d } = t;
  let o = r ? s.primary.main : s.gray[800];
  return n && (o = s.gray[600]), {
    color: o,
    fontSize: (l = d.medium) == null ? void 0 : l.fontSize,
    fontWeight: r ? d.fontWeightBold : d.fontWeightMedium,
    label: "titleStyle",
    margin: `0 0 ${e ? "-1px" : 0} 0`,
    textAlign: e ? "left" : "center",
    ...T(a, "title") ? {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    } : {},
    "&:after": {
      display: "block",
      content: "attr(title)",
      fontWeight: d.fontWeightBold,
      height: "1px",
      color: "transparent",
      overflow: "hidden",
      visibility: "hidden"
    }
  };
}), Te = y(
  "label",
  $
)(({ boxWidth: e, type: r, hasDescription: n, hasIcon: a, isChecked: t, isDisabled: s, theme: d }) => {
  const { palette: o, spacing: l } = d;
  let h = 0, p = 192, b = 400, f = l(2, 4, 2, 2), u = t ? o.primary.main : o.gray[500];
  s && (u = o.gray[300]);
  let m = t ? o.common.white : o.gray[300], j = t ? o.primary.main : "transparent", S = t ? o.primary.main : o.gray[300];
  function W(w) {
    return {
      width: w ? 21 : 20,
      height: w ? 21 : 20,
      bottom: w ? -1 : 0,
      right: w ? -1 : 0
    };
  }
  return s && (m = t ? o.common.white : "transparent", j = t ? o.gray[500] : "transparent", S = t ? o.gray[500] : "transparent"), a && !n && (h = 92, p = 120, b = 256, f = "20px 32px 16px"), {
    backgroundColor: o.common.white,
    borderRadius: 2,
    border: "1px solid",
    borderColor: u,
    boxSizing: "border-box",
    cursor: "pointer",
    display: "inline-block",
    minHeight: h,
    height: "100%",
    // Only set min and max widths if `boxWidth` has not been specified
    ...e ? void 0 : {
      maxWidth: b,
      minWidth: p
    },
    outline: "none",
    padding: f,
    position: "relative",
    label: "base",
    width: "100%",
    "&:after": {
      background: "none",
      border: "2px solid",
      borderColor: m,
      borderRadius: 0,
      borderRight: "none",
      borderTop: "none",
      bottom: 8,
      boxSizing: "border-box",
      content: '""',
      display: t || r === "checkbox" ? "block" : "none",
      height: 6,
      position: "absolute",
      right: 4,
      transform: "rotate(-50deg)",
      width: 11
    },
    "&:before": {
      backgroundColor: j,
      borderStyle: "solid",
      borderWidth: "1px 0 0 1px",
      borderColor: S,
      borderTopLeftRadius: 4,
      borderBottomRightRadius: ee,
      boxSizing: "border-box",
      content: '""',
      display: t || r === "checkbox" ? "block" : "none",
      margin: 0,
      position: "absolute",
      ...W(t)
    },
    ".SelectableBox > .SelectableBox__input:active + &, &:hover": {
      borderColor: g(t ? E : "gray8"),
      boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.1)",
      "&::before, &::after": {
        display: "block"
      }
    },
    ".SelectableBox > .SelectableBox__input:focus + &:hover": {
      "&::before": {
        backgroundColor: g(t ? E : "white"),
        borderColor: g(t ? E : "gray3")
      },
      "&::after": {
        borderColor: g(t ? "white" : "gray3")
      }
    }
  };
}), We = y("input")(() => ({
  height: 1,
  opacity: 0,
  position: "absolute",
  width: 1
})), Be = X()((e) => {
  const { spacing: r } = e;
  return {
    upperContent: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      padding: r(2.5)
    }
  };
}), Le = ({ children: e }) => {
  const { classes: r } = Be();
  return /* @__PURE__ */ i.jsx("div", { className: r.upperContent, children: e });
}, Ne = (e) => {
  const {
    apiRef: r,
    ariaDescribedby: n,
    containerRef: a,
    biId: t,
    boxWidth: s = V.ifFeature("encore", "320px", "auto"),
    /* @startCleanup encore */
    children: d,
    classes: o = {},
    className: l,
    /* @endCleanup encore */
    description: h,
    icon: p,
    inputId: b,
    inputProps: f,
    isChecked: u = !1,
    isDisabled: m = !1,
    truncated: j = !1,
    name: S,
    onBlur: W,
    onChange: w,
    status: I,
    errorMessage: A,
    warningMessage: U,
    title: R,
    type: B = "radio",
    upperContent: z,
    value: G
  } = e, { classes: c, cx: D } = ge({ boxWidth: s, isChecked: u, isDisabled: m, upperContent: z });
  if (!d && !R)
    throw new Error("must have a title or children to render");
  const L = re(null);
  ie(
    r,
    () => ({
      focus: () => {
        var k;
        (k = L.current) == null || k.focus();
      }
    }),
    [L]
  );
  const v = {
    boxWidth: s,
    hasDescription: !!h,
    hasIcon: !!p,
    isChecked: u,
    isDisabled: m,
    truncated: j,
    type: B
  }, J = ne(() => oe.uniqueId("status-message"), []), q = I === "error" && A || I === "warning" && U, K = be(q ? J : "", n), te = /* @__PURE__ */ i.jsxs(
    Ce,
    {
      className: N("SelectableBox", o.root, l),
      "data-bi-id": t,
      ref: a,
      ...v,
      children: [
        /* @__PURE__ */ i.jsx(
          We,
          {
            ...f,
            "aria-describedby": K,
            checked: u,
            className: N("SelectableBox__input", o.input),
            disabled: m,
            id: b,
            name: S,
            onBlur: W,
            onChange: (k) => {
              const {
                target: { name: F, value: H }
              } = k;
              w(F, H);
            },
            readOnly: !0,
            ref: L,
            type: B,
            value: G || S
          }
        ),
        /* @__PURE__ */ i.jsx(Te, { ...v, className: o.label, htmlFor: b, children: d || /* @__PURE__ */ i.jsxs($e, { ...v, className: o.content, children: [
          p && /* @__PURE__ */ i.jsx(
            ke,
            {
              "aria-hidden": !0,
              className: N("SelectableBox__icon", o.icon),
              ...v,
              children: typeof p == "string" ? /* @__PURE__ */ i.jsx(ae, { name: p == null ? void 0 : p.trim() }) : p
            }
          ),
          /* @__PURE__ */ i.jsxs(Ie, { ...v, className: o.text, children: [
            /* @__PURE__ */ i.jsx(De, { className: N("SelectableBox__title", o.title), ...v, children: R }),
            h && /* @__PURE__ */ i.jsx(je, { ...v, className: o.description, children: h })
          ] })
        ] }) })
      ]
    }
  );
  let M;
  m ? M = "muted" : u && (M = "primary");
  const _ = T(j, "title"), P = T(j, "description");
  return V.ifFeature(
    "encore",
    /* @__PURE__ */ i.jsxs("div", { className: c.container, "data-fabric-component": "SelectableBox", children: [
      /* @__PURE__ */ i.jsxs(
        "label",
        {
          className: D(c.root, { [c.checked]: u, [c.disabled]: m }),
          "data-bi-id": t,
          htmlFor: b,
          ref: a,
          children: [
            !!z && /* @__PURE__ */ i.jsx("div", { className: c.upperContent, children: z }),
            /* @__PURE__ */ i.jsxs("div", { className: D(c.inner, { [c.truncatedTextWrapper]: _ || P }), children: [
              /* @__PURE__ */ i.jsx(
                "input",
                {
                  ...f,
                  "aria-describedby": K,
                  "aria-invalid": I === "error",
                  checked: u,
                  className: c.input,
                  disabled: m,
                  id: b,
                  name: S,
                  onBlur: W,
                  onChange: (k) => {
                    const {
                      target: { name: F, value: H }
                    } = k;
                    w(F, H);
                  },
                  readOnly: !0,
                  ref: L,
                  type: B,
                  value: G || S
                }
              ),
              p && /* @__PURE__ */ i.jsx("div", { className: c.iconTile, children: /* @__PURE__ */ i.jsx(se, { icon: p, size: 48, variant: M }) }),
              /* @__PURE__ */ i.jsxs("div", { className: D(c.textWrapper, { [c.truncatedTextWrapper]: _ || P }), children: [
                /* @__PURE__ */ i.jsx("p", { className: D(c.title, { [c.truncatedText]: _ }), children: R }),
                h && /* @__PURE__ */ i.jsx("p", { className: D(c.description, { [c.truncatedText]: P }), children: h })
              ] }),
              B === "checkbox" && /* @__PURE__ */ i.jsx("div", { className: c.checkbox, children: /* @__PURE__ */ i.jsx("div", { className: c.checkboxInner, children: /* @__PURE__ */ i.jsx(le, { name: "check-solid", size: 12 }) }) })
            ] })
          ]
        }
      ),
      q && /* @__PURE__ */ i.jsx(ce, { marginTop: 1, children: /* @__PURE__ */ i.jsx(
        de,
        {
          id: J,
          message: I === "error" ? A : U,
          showIcon: !0,
          status: I,
          width: 100
        }
      ) })
    ] }),
    te
  );
};
Ne.UpperContent = Le;
export {
  Ne as S
};
//# sourceMappingURL=selectable-box-BqzFKtVw.mjs.map
